import { Skeleton } from "@/components/ui/skeleton";

/** Loading placeholder that mirrors the member-section layout so nothing jumps on first paint. */
export const TeamListSkeleton = () => (
  <div className="space-y-6">
    {[1, 2].map((i) => (
      <div key={i} className="overflow-hidden rounded-xl border border-border bg-card shadow-sm">
        <div className="flex items-center gap-4 border-b border-border bg-muted/30 p-5">
          <Skeleton className="h-12 w-12 rounded-full" />
          <div className="flex-1">
            <Skeleton className="mb-2 h-6 w-48" />
            <Skeleton className="h-4 w-32" />
          </div>
          <Skeleton className="h-8 w-24 rounded-full" />
        </div>
        <div className="p-5">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
            <Skeleton className="h-[180px] w-full rounded-xl" />
            <Skeleton className="hidden h-[180px] w-full rounded-xl md:block" />
            <Skeleton className="hidden h-[180px] w-full rounded-xl xl:block" />
          </div>
        </div>
      </div>
    ))}
  </div>
);
